import Lottie from 'lottie-react';
import { twMerge } from 'tailwind-merge';
import animationData from '../../assets/animations/VayuLoaderFinal.json';

type SpinnerProps = {
  containerClassName?: string;
  centerPage?: boolean;
  size?: number;
};

export const Spinner: React.FC<SpinnerProps> = ({ containerClassName, centerPage = true, size = 90 }) => {
  const centeredSpinnerClassName = twMerge(
    'flex h-full w-full justify-center items-center bg-[rgba(245,245,245,0.38)]',
    containerClassName,
  );

  return (
    <div
      data-vy="spinner"
      role="status"
      className={centerPage ? centeredSpinnerClassName : containerClassName}
    >
      <Lottie animationData={animationData} loop={true} style={{ width: size, height: size }} />
    </div>
  );
};
